import { useMutation } from "@tanstack/react-query";
import fetchData from "../fetcher";
import { SignupPayload, SignupResponse } from "./types";

export const useSignUp = () => {
    const { mutateAsync, data, isPending, error, isError } = useMutation({
        mutationKey: ["login"],
        mutationFn: (body: SignupPayload) => fetchData<SignupResponse>("/iam/v4/auth/signup", { body, method: "POST" }),
    });

    return { mutateAsync, data, isPending, error, isError };
}